import { useMemo } from 'react';

import { isClientHydrated } from '#/rendering/state/renderingState';

export function useFirstRenderType() {
  const firstRenderType = useMemo(
    () => (isClientHydrated() ? 'client' : 'server'),
    [],
  );

  return { firstRenderType };
}
